module.exports = __webpack_public_path__ + "47d03191fed2ef93f2c006d15698e2e5.png";